import React from "react";

const CertificateExpiryDate = () => {
  return <div>CertificateExpiryDate</div>;
};

export default CertificateExpiryDate;
